<div [ngClass]="sizeClass()">
  <span>{{ firstWord() }}</span>
  <span>{{ secondWord() }}</span>
</div>
